// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Modern Pagination ───────────────────────────────────────────────────── */
nav .pagination {
  display: flex;
  align-items: center;
  gap: 2px;
  list-style: none;
  padding: 0;
  margin: 0;
}

.page-item {
  display: flex;
}

.page-link {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 32px;
  height: 32px;
  padding: 0 6px;
  border-radius: 6px;
  border: none;
  background: transparent;
  color: #374151;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  text-decoration: none;
  transition: background 0.12s, color 0.12s;
  line-height: 1;
  font-family: inherit;
}

.page-link:hover {
  background: #F1F5F9;
  color: #0F172A;
}

.page-item.active .page-link {
  background: #0F172A;
  color: #ffffff;
  font-weight: 600;
  border-radius: 6px;
}

.page-item.disabled .page-link,
.page-link[disabled] {
  color: #CBD5E1;
  cursor: default;
  pointer-events: none;
}
`, "",{"version":3,"sources":["webpack://./src/pages/homeDashboard/components/Pagination/Pagination.css"],"names":[],"mappings":"AAAA,+EAA+E;AAC/E;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,yCAAyC;EACzC,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB","sourcesContent":["/* ── Modern Pagination ───────────────────────────────────────────────────── */\nnav .pagination {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.page-item {\n  display: flex;\n}\n\n.page-link {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 32px;\n  height: 32px;\n  padding: 0 6px;\n  border-radius: 6px;\n  border: none;\n  background: transparent;\n  color: #374151;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  text-decoration: none;\n  transition: background 0.12s, color 0.12s;\n  line-height: 1;\n  font-family: inherit;\n}\n\n.page-link:hover {\n  background: #F1F5F9;\n  color: #0F172A;\n}\n\n.page-item.active .page-link {\n  background: #0F172A;\n  color: #ffffff;\n  font-weight: 600;\n  border-radius: 6px;\n}\n\n.page-item.disabled .page-link,\n.page-link[disabled] {\n  color: #CBD5E1;\n  cursor: default;\n  pointer-events: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
